<div class="categories">
  @if (currentDevice === EDevices.desktop) {
  <div class="categories__list">
    @for (category of categories; track category) {
    <app-category-dropdown [category]="category"
                           (itemSelected)="gotTo($event.codeId)"></app-category-dropdown>
    }
  </div>
  } @else {
  <dds-button width="full"
              kind="primary"
              theme="dark"
              size="lg"
              [isInverse]="true"
              [ddsSticker]="customDropdownMenu"
              [stickerIsOutsideClick]="true"
              stickerPosition="bottom"
              [stickerIndent]="-15"
              stickerCustomClass="categories-popup"
              class="categories__btn"
              (onShown)="onShownCategories(categoriesBtn)"
              (onHidden)="onHiddenCategories(categoriesBtn)"
              #stickerDir="dds-sticker"
              #categoriesBtn>
    Categories
    <span class="categories__btn-icon dds-icon dds-icon_chevron_down__s__stroke"></span>
  </dds-button>

  <ng-template #customDropdownMenu>
    <div class="categories-popup__content">

      <dds-accordion [isInverse]="true">
        @for (category of categories; track category) {
        <dds-accordion-item>
          <span header>{{category.title}}</span>
          <div content
               class="categories-popup__list">
            @for(article of category.list; track article) {
            <span (click)="gotTo(article.codeId); stickerDir.hide()"
                  class="categories-popup__article">{{article.title}}</span>
            }
          </div>
        </dds-accordion-item>
        }
      </dds-accordion>

    </div>
  </ng-template>
  }
</div>
